import { useEffect, useState } from "react";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import Newsletter from "../components/site/Newsletter";
import { api } from "../lib/api";
import { motion } from "framer-motion";

export default function BlogPage() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data.posts || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="blog-page">
      <Navbar />
      <section className="pt-36 pb-16 bg-radial-sky">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-xs tracking-[0.3em] uppercase text-[#1D4E89] font-medium mb-5">
            The RBICA Journal
          </div>
          <h1 className="font-serif text-5xl md:text-6xl text-[#0B2B40] font-light tracking-tight leading-[1.05] max-w-3xl">
            Slow notes on <span className="italic">rising from within.</span>
          </h1>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-3 gap-10">
          {posts.map((p, i) => (
            <motion.article
              key={p.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="group"
              data-testid={`blog-page-card-${p.id}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={p.image} alt={p.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="mt-5 text-xs tracking-[0.2em] uppercase text-[#1D4E89]">
                {p.category} · {p.read_time}
              </div>
              <h3 className="font-serif text-2xl text-[#0B2B40] mt-3 leading-snug">{p.title}</h3>
              <p className="mt-3 text-[#4A5568] leading-relaxed">{p.excerpt}</p>
              <div className="mt-4 text-xs uppercase tracking-[0.18em] text-[#4A5568]">{p.date}</div>
            </motion.article>
          ))}
        </div>
      </section>

      <Newsletter />
      <Footer />
    </div>
  );
}
